import { HvlFormConstants } from '@hvlng/framework-core/form';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectedPersonnelService } from '../service/selected-personnel.service';
import { PageCodeModel } from './page-code-model';
import { PersonnelData } from '../model/personnel-data';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormGroup } from '@angular/forms';
import { HrHvlFormGroup } from '../model/hr-hvlng-form-group';
import { HrTranslateKey } from '../translate/hr-translate-key';

import { UiToastMessageService, UiTranslateLoaderService } from 'ui-shared';
import { HrMasterDataRouterConstants } from '../constant/hr-master-data-router-constants';
import { Subscription } from 'rxjs';

export function getPageCode(formMode: HvlFormConstants, pageCodeModel: PageCodeModel): string {
    if (formMode === HvlFormConstants.ADD || formMode === HvlFormConstants.COPY) {
        return pageCodeModel.addCopy;
    } else if (formMode === HvlFormConstants.EDIT) {
        return pageCodeModel.edit;
    } else if (formMode === HvlFormConstants.LIST) {
        return pageCodeModel.list;
    } else if (formMode === HvlFormConstants.REMOVE) {
        return pageCodeModel.remove;
    }
}

export function subscribePeople(
    personnelService: SelectedPersonnelService,
    router: Router,
    onDataCame: (people: PersonnelData) => void,
): Subscription {
    return personnelService.dataPeople$.subscribe((data) => {
        if (data === null) {
           // goPersonnelSearch(router);
        } else {
            onDataCame(data);
        }
    });
}

export function subscribePeopleData(
    personnelService: SelectedPersonnelService,
    onDataCame: (people: PersonnelData) => void,
) {
    personnelService.dataPeople$.subscribe((data) => {
        if(data !=null)
        onDataCame(data);
    });
}

export function goPersonnelSearch(router?: Router) {
    router?.navigate(['humanresources/personnel/profile']);
}

export function goMasterData(router?: Router, params?: { boxesRoute?: string; customUrl?: string }) {
    if (params?.customUrl) {
        router?.navigate([params.customUrl],{ skipLocationChange: true });
    } else {
        if (params?.boxesRoute) {
            router?.navigate([HrMasterDataRouterConstants.MASTER_DATA_MAIN_ROUTE + '/' + params.boxesRoute],{ skipLocationChange: true });
        } else {
            router?.navigate([HrMasterDataRouterConstants.MASTER_DATA_MAIN_ROUTE],{ skipLocationChange: true });
        }
    }
}

export async function getFormTitleAsync(
    translateService: TranslateService,
    pageTitleKey: string,
    formMode?: HvlFormConstants,
): Promise<string | any> {
    let isResolved = false;
    const formTitleKey = getFormTitleKey(formMode);
    return new Promise<string>((resolve) => {
        setTimeout(() => {
            if (!isResolved) {
                console.error(`You have to add '${pageTitleKey}' to your resource json`);
                resolve(pageTitleKey);
            }
        }, 3000);
        translateService.stream(pageTitleKey).subscribe((pageTitleValue) => {
            if (pageTitleKey === pageTitleValue) {
                return;
            }
            translateService.stream(formTitleKey, { item: pageTitleValue }).subscribe((formTitleValue) => {
                if (formTitleKey !== formTitleValue) {
                    isResolved = true;
                    resolve(formTitleValue);
                }
            });
        });
    });
}

export function getFormTitle(
    translateService: UiTranslateLoaderService,
    pageTitleKey: string,
    formMode: HvlFormConstants,
): string | any {
    const formTitleKey = getFormTitleKey(formMode);
    return translateService.instant(formTitleKey, { item: translateService.instant(pageTitleKey) });
}

export function getFormTitleSync(
    translateService: TranslateService,
    pageTitleKey: string,
    formMode: HvlFormConstants,
): string | any {
    const formTitleKey = getFormTitleKey(formMode);
    return translateService.instant(formTitleKey, { item: translateService.instant(pageTitleKey) });
}

function getFormTitleKey(formMode?: HvlFormConstants): string {
    let formTitleKey;
    if (formMode == null) {
        formTitleKey = HrTranslateKey.hrCommon.searchTitle;
    } else if (formMode == HvlFormConstants.ADD) {
        formTitleKey = HrTranslateKey.hrCommon.addTitle;
    } else if (formMode == HvlFormConstants.REMOVE) {
        formTitleKey = HrTranslateKey.hrCommon.removeTitle;
    } else if (formMode == HvlFormConstants.LIST) {
        formTitleKey = HrTranslateKey.hrCommon.listTitle;
    } else if (formMode == HvlFormConstants.EDIT) {
        formTitleKey = HrTranslateKey.hrCommon.editTitle;
    } else if (formMode == HvlFormConstants.COPY) {
        formTitleKey = HrTranslateKey.hrCommon.copyTitle;
    }
    return formTitleKey;
}

export function clearBrackets(value: string): string {
    if (value == null) {
        return null;
    }
    return value.replace('{{', '').replace('}}', '');
}

export function capitalizeFirstLetter(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1);
}

export function deCapitalizeFirstLetter(word: string): string {
    return word.charAt(0).toLowerCase() + word.slice(1);
}

function fixHrModelName(modelName: string): string {
    if (modelName.startsWith('Per')) {
        modelName = modelName.slice(3);
    }
    if (modelName.endsWith('Model')) {
        modelName = modelName.slice(0, -5);
    }
    modelName = deCapitalizeFirstLetter(modelName);
    return modelName;
}

export function generateInputId(formGroup: UntypedFormGroup, name: string): string {
    const fg = formGroup as HrHvlFormGroup<any>;
    return fixHrModelName(fg.getClassName()) + capitalizeFirstLetter(name);
}

export function translateAsync(translateService: TranslateService, key: string): Promise<string | any> {
    let isResolved = false;
    return new Promise<string | any>((resolve) => {
        setTimeout(() => {
            if (!isResolved) {
                console.error(`You have to add '${key}' to your resource json`);
                resolve(key);
            }
        }, 3000);
        translateService.stream(key).subscribe((value) => {
            if (key !== value) {
                isResolved = true;
                resolve(value);
            }
        });
    });
}

export function onServiceError(
    uiToastMessageService: UiToastMessageService,
    translateService: UiTranslateLoaderService,
    resource: string,
    err: any,
    useWarningToast?: boolean,
) {
    showErrorMessage(uiToastMessageService, translateService, resource, err.error, useWarningToast);
}

/**
 * Response Content Type'i JSON olmayıp byte[] olan(Ö: Jasper raporları) endpointlerden fırlatılan exceptionları handle etmek için eklendi
 */
export async function onServiceBlobTypeError(
    uiToastMessageService: UiToastMessageService,
    translateService: UiTranslateLoaderService,
    err: any,
    useWarningToast?: boolean,
) {
    if (!err) return;
    let jsonError;
    if (err.error instanceof Blob) {
        jsonError = await new Response(err.error).json();
    } else {
        jsonError = err.error;
    }
    showErrorMessage(uiToastMessageService, translateService, '', jsonError, useWarningToast);
}

function showErrorMessage(
    uiToastMessageService: UiToastMessageService,
    translateService: UiTranslateLoaderService,
    resource: string,
    error: any,
    useWarningToast?: boolean,
) {
    let errorCode = error.errorDetail?.errorCode;
    if (!errorCode && error.errorDetail.errorMessage.includes('ConstraintViolationException')) {
        errorCode = 'ERR_HBRNT_CONST_VIOLAT_001';
    }
    if (errorCode) {
        if (errorCode === 'ERR_HBRNT_CONST_VIOLAT_001' && error.errorDetail?.errorArguments?.length > 0) {
            let errMsg = error.errorDetail.errorArguments
                .map((it) => translateService.instant(resource + '.' + it))
                .join(', ');
            uiToastMessageService.showError(translateService.instant(errorCode, [errMsg]));
        } else {
            if (useWarningToast) {
                uiToastMessageService.showWarn(translateService.instant(errorCode));
            } else {
                const errorMessage = error.errorDetail?.errorMessage;
                const errorArguments = error.errorDetail?.errorArguments;
                uiToastMessageService.showError(
                    translateService.instant(errorCode, errorArguments ? errorArguments : [errorMessage]),
                );
            }
        }
    } else {
        uiToastMessageService.showError(translateService.instant('generic_error_detail'));
    }
}

export interface BackButtonRouteQueryParams {
    showBack: boolean;
    customBackRoute: string;
    label?: string;
}

export function subscribeBackBtnRouteQueryParams(
    route: ActivatedRoute,
    onDataCame: (queryParams: BackButtonRouteQueryParams) => void,
) {
    route.queryParamMap.subscribe((params) => {
        let showBack: boolean = null;
        let customBackRoute: string = null;
        let label: string = null;
        if (params.has(HrMasterDataRouterConstants.SHOW_BACK_QUERY_PARAM)) {
            try {
                showBack = Boolean(JSON.parse(params.get(HrMasterDataRouterConstants.SHOW_BACK_QUERY_PARAM)));
            } catch (err) {}
        }
        if (params.has(HrMasterDataRouterConstants.CUSTOM_BACK_ROUTE_QUERY_PARAM)) {
            customBackRoute = params.get(HrMasterDataRouterConstants.CUSTOM_BACK_ROUTE_QUERY_PARAM);
        }
        if (params.has(HrMasterDataRouterConstants.LABEL_ROUTE_QUERY_PARAM)) {
            label = params.get(HrMasterDataRouterConstants.LABEL_ROUTE_QUERY_PARAM);
        }
        onDataCame({
            showBack: showBack,
            customBackRoute: customBackRoute,
            label: label,
        });
    });
}
